import { render, staticRenderFns } from "./roadmap.vue?vue&type=template&id=78b06708&scoped=true"
import script from "./roadmap.vue?vue&type=script&lang=js"
export * from "./roadmap.vue?vue&type=script&lang=js"
import style0 from "./roadmap.vue?vue&type=style&index=0&id=78b06708&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b06708",
  null
  
)

export default component.exports